const firebaseDomain = process.env.NODE_ENV === 'development' ?
  `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJ_ID}/us-central1/api` :
  `https://${process.env.REACT_APP_WEB_HOST_URI}/api`

// Direct Cloud Function URL for file uploads.
// May be blocked by school firewalls — authFetchHandler falls back to uploadDomain.
const cloudFunctionDomain = process.env.NODE_ENV === 'development' ?
  `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJ_ID}/us-central1/api` :
  `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJ_ID}.cloudfunctions.net/api`

// Fallback for file uploads via Firebase Hosting (whitelisted by schools).
// Uses the standalone fileUpload Cloud Function.
const uploadDomain = process.env.NODE_ENV === 'development' ?
  `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJ_ID}/us-central1/fileUpload` :
  `https://${process.env.REACT_APP_WEB_HOST_URI}/upload`

export { firebaseDomain, cloudFunctionDomain, uploadDomain }